import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Assembler, GatewayState } from '@iotv/datamodel-core';
import { AppValueTypes } from '@iotv/iotv-v3-types';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import { Box, Button, Card, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { DialogWrapper } from '../../../components/common/DiaglogWrapper';
import AppDao from '../../../data/AppDao';
import { link } from '../../../data/daoFunctions/daoFunctions';
import { StaticLoadingAnimation } from '../../../Popup/Loading';
import { AdjacentType, ComponentMode, ObjectViewType, ShowDefinedEntriesOnlyOpts, } from '../../../types/AppTypes';
import { ObjectDetailCard } from '../../../v2/components/generic/ObjectView/ObjectDetailCard';
import { Listerlizer } from '../../factories/Listerlizer/Listerlizer';
import styles from './ProvisionCard.module.css';
const DEFAULT_DESCRIPTION = 'Default Gateway Group';
const delay = (ms) => new Promise((res) => setTimeout(res, ms));
/** @deprecated - No longer used */
const ProvisionCard = (props) => {
    const { user, customerOptions, devices, userFunctions, customerMapper, transactionFunctions, close } = props;
    const [saving, setSaving] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState();
    const [selectedObjects, setSelectedObjects] = useState([]);
    const [noGroup, setNoGroup] = useState(false);
    const [stop, setStop] = useState(false);
    useEffect(() => {
        if (selectedObjects && selectedCustomer) {
            if (!noGroup && !stop) {
                assignToCustomer(selectedObjects, selectedCustomer);
            }
            else {
                setStop(false);
            }
        }
    }, [noGroup]);
    useEffect(() => {
        if (stop === true) {
            setNoGroup(false);
        }
    }, [stop]);
    const mutatedTransactionFunctions = {
        ...transactionFunctions,
        saveObject: async (vob) => {
            if (selectedCustomer) {
                const edgeAttributes = undefined;
                transactionFunctions.saveAndLinkObject(selectedCustomer.sk, vob, {
                    adjacentType: AdjacentType.CHILD,
                    objectType: 'Gateway',
                }, edgeAttributes);
                await delay(4000);
                setNoGroup(false);
            }
        },
    };
    const getListerlizer = (context) => {
        return {
            initMode: ComponentMode.EDIT,
            transactionFunctions,
            userFunctions,
            adjacentFilter: {
                adjacentType: AdjacentType.CHILD,
                objectType: 'Gateway',
            },
            autoQuery: true,
            columnVisibilityReferences: {
                dataTableReference: 'List',
                objectTypeId: 'ValidBusinessObject',
                viewType: ObjectViewType.List,
                externalColumnVisibility: undefined,
            },
            viewDefinition: {
                name: {
                    key: 'name',
                    type: AppValueTypes.STRING,
                    label: 'Gateway',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                id: {
                    key: 'id',
                    type: AppValueTypes.STRING,
                    label: 'ID',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                // group: {
                //   key: 'group',
                //   type: AppValueTypes.STRING,
                //   label: 'Group',
                //   editable: false,
                //   precision: undefined,
                //   stateFn: undefined,
                //   unit: undefined,
                //   validationRx: undefined,
                //   enumKV: undefined,
                // },
                customer: {
                    key: 'customer',
                    type: AppValueTypes.STRING,
                    label: 'Customer',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                lastSeen: {
                    key: 'lastSeen',
                    type: AppValueTypes.DATE,
                    label: 'Last Seen',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
            },
            viewObject: {
                matchedPrimary: undefined,
                matchedRelatedByPk: [],
                matchedRelatedBySk: context,
            },
            contextObject: undefined,
            searchRootObject: undefined,
            onSelectedUpdate: setSelectedObjects,
        };
    };
    const updateSelectedCustomer = (id, customers) => {
        const found = customers.find((customer) => customer.id === id);
        setSelectedCustomer(found);
    };
    const getSimpleGroup = () => {
        const newObject = Assembler.getInstance({ type: 'Group' });
        newObject.supportedType = 'Gateway';
        newObject.description = DEFAULT_DESCRIPTION;
        return newObject;
    };
    const assignToCustomer = async (gateways, customer) => {
        setSaving(true);
        ////// start of mapping logic
        const getCustomersGroup = async (cust) => {
            const mapperPromise = await AppDao.queryByGraph({
                contextObjects: [cust],
                path: [
                    { objectTypeId: 'Group', adjacencyType: AdjacentType.CHILD },
                    { objectTypeId: 'Gateway', adjacencyType: AdjacentType.CHILD },
                ],
            });
            if (mapperPromise.err === null && mapperPromise.data) {
                const items = mapperPromise.data.getContainedItems();
                const existList = items.filter((item) => item.type === 'Group' && item.supportedType === 'Gateway' && item.description === DEFAULT_DESCRIPTION);
                if (existList.length === 0) {
                    return undefined;
                }
                else {
                    return existList[0];
                }
            }
            else {
                return undefined;
            }
        };
        const group = await getCustomersGroup(customer);
        if (!group) {
            setNoGroup(true);
            return;
        }
        setSaving(true);
        ///// get group
        const gatewayLinkPromises = gateways.map((gateway) => {
            return link(group, gateway);
        });
        // unlink existing gateway group
        // let gatewayUnlinkPromises = gateways.map((gateway) => {
        //   let groups = customerMapper.getParentNodes(gateway) as ValidBusinessObjectList;
        //   if (groups.length === 1) {
        //     return unlink(gateway, groups[0]);
        //   }
        // });
        // Promise.all([...gatewayLinkPromises, ...gatewayUnlinkPromises]).then((res) => {
        Promise.all(gatewayLinkPromises).then((res) => {
            //completed all gateway links
            gateways.forEach((gateway) => {
                AppDao.getExact(gateway).then(async (fromDB) => {
                    if (fromDB.data?.Items !== undefined && fromDB.data.Items.length === 1) {
                        const exact = fromDB?.data?.Items[0];
                        AppDao.save({ ...exact, state: GatewayState.COMMISSIONED }).then(() => {
                            setSaving(false);
                            close();
                        });
                    }
                    else {
                        setSaving(false);
                        close();
                    }
                });
            });
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Card, { children: [_jsx("div", { id: "Provision-Header", children: _jsxs(Stack, { direction: "row", spacing: 2, sx: { justifyContent: 'space-between', alignItems: 'center' }, children: [_jsx(DialogTitle, { id: "alert-dialog-title", children: "Assign Gateway" }), _jsx(IconButton, { edge: "end", color: "warning", onClick: close, "aria-label": "close", children: _jsx(Box, { sx: { m: 1 }, children: _jsx(CancelPresentationIcon, {}) }) })] }) }), _jsx("div", { className: styles.provisionBody, children: _jsx(Box, { sx: { m: 1 }, children: _jsx(Listerlizer, { ...getListerlizer(devices) }) }) }), _jsx(Box, { sx: { m: 2 }, children: _jsxs(Stack, { direction: "row", spacing: 2, sx: { justifyContent: 'flex-end', alignItems: 'center' }, children: [_jsx("div", { style: { width: '300px' }, children: _jsxs(FormControl, { fullWidth: true, children: [_jsx(InputLabel, { id: "customer-label", children: "Select Customer" }), _jsx(Select, { labelId: "customer-label", id: "customer-select", value: selectedCustomer?.name, label: "Customers", onChange: (e) => {
                                                    updateSelectedCustomer(e.target.value, customerOptions);
                                                }, children: customerOptions.map((customer) => (_jsx(MenuItem, { value: customer.id, children: customer.name }, customer.sk))) })] }) }), _jsx(Button, { variant: "contained", color: "primary", disabled: selectedCustomer === undefined || selectedObjects.length === 0, onClick: () => assignToCustomer(selectedObjects, selectedCustomer), children: "Apply" })] }) })] }), _jsx(DialogWrapper, { header: `Add Gateway Group to ${selectedCustomer?.name}`,
                open: noGroup,
                setClosed: (actioned) => {
                    setStop(true);
                },
                children: noGroup ? (_jsx(ObjectDetailCard, { transactionFunctions: mutatedTransactionFunctions,
                    matchedPrimary: getSimpleGroup(),
                    mostProximateCustomer: undefined,
                    definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes,
                    allowedActions: undefined,
                    userFunctions,
                    viewDefinition: {
                        name: {
                            key: 'name',
                            label: 'Name',
                            type: AppValueTypes.STRING,
                            editable: true,
                            unit: undefined,
                            precision: undefined,
                            stateFn: undefined,
                            validationRx: undefined,
                        },
                        description: {
                            key: 'description',
                            label: 'Description',
                            type: AppValueTypes.STRING,
                            editable: false,
                            unit: undefined,
                            precision: undefined,
                            stateFn: undefined,
                            validationRx: undefined,
                        },
                    } })) : (_jsx(_Fragment, {})) }, 'newObjectDialog'), saving && _jsx(StaticLoadingAnimation, { message: 'Provisioning Gateways, Please Wait...' })] }));
};
export default ProvisionCard;
